import { FC } from 'react';
import { useTestResults } from './hooks/useTestResult';
import { Test } from '../types';
import { TestStatus } from '@agilelab/plugin-wb-platform';

interface Props {
  test: Test;
}

export const TestStatusColumn: FC<Props> = ({ test }) => {
  const { policiesWithWarnings } = useTestResults(test);

  return (
    <TestStatus
      status={test.status}
      okWithWarnings={!!policiesWithWarnings}
      variant="reduced"
    />
  );
};
